import React from "react";

const Paginator = ({ currentPage, totalPages, onPageChange }) => {
    return (
        <div className="paginator">
            <button className="paginator-btn-prev" 
                onClick={() => onPageChange(currentPage - 1)} 
                disabled={currentPage === 1}
            >
                Previous
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
                <button 
                    key={i + 1} 
                    onClick={() => onPageChange(i + 1)}
                    className={currentPage === i + 1 ? "paginator-btn-page active" : "paginator-btn-page"}
                >
                    {i + 1}
                </button>
            ))}

            <button className="paginator-btn-next"
                onClick={() => onPageChange(currentPage + 1)} 
                disabled={currentPage === totalPages}
            >
                Next
            </button>
        </div>
    );
};

export default Paginator;
